var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading-elements"},[_c('ul',{staticClass:"list-inline mb-0"},[_c('li',[_c('a',{on:{"click":_vm.toggleCollapse}},[(_vm.openStatus)?_c('SVGMinimemIcon'):_c('SVGMaximumIcon')],1)]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }